import type { AdminOrganizationDetail } from '../../../../domain/superadmin/types';
import { formatDate } from '../../../../utils/formatters';
import DashboardCard from '../../../dashboard/components/DashboardCard';
import { cn } from '@/lib/utils';
import { TICKET_STATUS_LABELS } from '../../tickets/ticketStatusLabels';
import type { TicketStatus } from '../../../../domain/support/guards';
import { SectionEmpty } from './SectionEmpty';

type TicketsSectionProps = {
  tickets: AdminOrganizationDetail['tickets'];
};

function ticketStatusLabel(status: string) {
  const key = status as TicketStatus;
  return TICKET_STATUS_LABELS[key] ?? status.replace(/_/g, ' ');
}

function ticketStatusClass(status: string) {
  const normalized = status.toLowerCase();
  if (normalized === 'open') return 'border-warning/30 bg-warning-bg text-warning-text';
  if (normalized === 'in_progress') return 'border-primary/30 bg-primary-subtle text-primary';
  return 'border-border bg-surface-subtle text-secondary';
}

export function TicketsSection({ tickets }: TicketsSectionProps) {
  return (
    <DashboardCard title="Tickets de suporte" className="mb-s5">
      {tickets.length === 0 ? (
        <SectionEmpty message="Nenhum ticket aberto para esta empresa." />
      ) : (
        <ul className="flex flex-col gap-s2">
          {tickets.map((ticket) => (
            <li
              key={ticket.id}
              className="flex flex-col gap-2 rounded-lg border border-subtle bg-surface px-s4 py-3 sm:flex-row sm:items-center sm:justify-between"
            >
              <div className="min-w-0">
                <p className="truncate text-[13px] font-medium text-default">{ticket.subject}</p>
                <p className="mt-0.5 font-mono text-[11.5px] tabular-nums text-muted">
                  {formatDate(ticket.createdAt)}
                </p>
              </div>
              <span
                className={cn(
                  'inline-flex w-fit shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-medium',
                  ticketStatusClass(ticket.status),
                )}
              >
                {ticketStatusLabel(ticket.status)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </DashboardCard>
  );
}
